(() => {
  const article = document.querySelector('[data-moreless]');
  if (!article) return;

  const paragraphs = article.querySelectorAll('p');
  if (paragraphs.length < 3) return;

  const moreButton = paragraphs[0].querySelector('button');
  const lessButton = paragraphs[2].querySelector('button');

  if (!moreButton || !lessButton) return;

  const expandable = [paragraphs[1], paragraphs[2]];

  // Przygotowanie animacji
  expandable.forEach((el) => {
    el.style.overflow = 'hidden';
    el.style.maxHeight = '0px';
    el.style.opacity = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    el.style.transition =
      'max-height 0.5s ease, opacity 0.35s ease, margin 0.5s ease';
  });

  // "Czytaj więcej" nie znika z layoutu
  moreButton.style.transition = 'opacity 0.2s ease';
  
  // "Zwiń" początkowo niewidoczne
  lessButton.style.display = 'none';

  const expand = () => {
    moreButton.setAttribute('aria-expanded', 'true');
    lessButton.setAttribute('aria-expanded', 'true');

    // Najpierw przygotuj wysokość
    expandable.forEach((el) => {
      el.style.maxHeight = `${el.scrollHeight}px`;
      el.style.opacity = '1';
      el.style.marginTop = '';
      el.style.marginBottom = '';
    });

    // "Czytaj więcej" znika płynnie, ale nie zmienia layoutu
    moreButton.style.opacity = '0';
    moreButton.style.pointerEvents = 'none';

    // Pokaż "Zwiń"
    lessButton.style.display = '';

    requestAnimationFrame(() => {
      lessButton.style.opacity = '1';
    });

    setTimeout(() => {
      expandable.forEach((el) => {
        el.style.maxHeight = 'none';
      });
    }, 500);
  };

  const collapse = () => {
    moreButton.setAttribute('aria-expanded', 'false');
    lessButton.setAttribute('aria-expanded', 'false');

    // Jeśli max-height jest "none", przywróć konkretną wartość
    expandable.forEach((el) => {
      el.style.maxHeight = `${el.scrollHeight}px`;

      requestAnimationFrame(() => {
        el.style.maxHeight = '0px';
        el.style.opacity = '0';
        el.style.marginTop = '0';
        el.style.marginBottom = '0';
      });
    });

    // "Zwiń" znika
    lessButton.style.opacity = '0';

    // "Czytaj więcej" pojawia się od razu,
    // dzięki czemu nie ma skoku po zakończeniu animacji
    moreButton.style.opacity = '1';
    moreButton.style.pointerEvents = '';

    setTimeout(() => {
      lessButton.style.display = 'none';
    }, 200);
  };

  moreButton.addEventListener('click', expand);
  lessButton.addEventListener('click', collapse);
})();